import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { getFiles, readFile } from '@ps/api/editor/file';
import router from '@ps/router';
import { mapState } from 'vuex';
import FileList from './FileList.vue';
import { qcAssetLoadAsync } from '@ps/utils/game';
export default {
  components: {
    FileList: FileList
  },
  data: function data() {
    return {
      dialogProps: {
        visible: false,
        title: '预设选择',
        modalAppendToBody: true,
        appendToBody: true,
        modal: true,
        width: '400px',
        closeOnPressEscape: false,
        closeOnClickModal: false
      },
      cloneLists: [], // 文件列表
      projectKey: '', // 当前项目 id
      curDir: '/resource/prefab/',
      stacks: [], // 文件列表历史记录
      dirStacks: [], // 文件夹历史记录,
      currentSelectedFile: [],
      loading: false
    };
  },

  computed: _extends({}, mapState({
    uuid2url: function uuid2url(state) {
      return state.workspace.game.uuid2url;
    },
    qc: function qc(state) {
      return state.workspace.game.data;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.loadingTitle = '正在获取资源';
    this.projectKey = router.currentRoute.query.id;

    getFiles({ pid: this.projectKey }).then(function (res) {
      // console.log(
      //   'res',
      //   res.data.result.items.filter((item) => item.name === '/resource/'),
      // )
      var prefab = res.data.result.items.filter(function (item) {
        return item.name === '/resource/';
      })[0].items.filter(function (item) {
        return item.name === '/resource/prefab/';
      })[0];
      _this.fileLists = prefab.items.filter(function (v) {
        return v.name.includes('.bin');
      }).sort(function (a, b) {
        return b.is_dir - a.is_dir;
      });
      _this.cloneLists = _this.fileLists;
      _this.curDir = prefab.name;
    }).catch(function (err) {
      _this.$message({
        type: 'error',
        message: err.code === 1 ? err.msg + '，获取资源失败' : err.msg
      });
    }).finally(function () {
      _this.loading = false;
    });
  },

  methods: {
    openDialog: function openDialog() {
      this.dialogProps.visible = true;
    },
    closeDialog: function closeDialog() {
      this.dialogProps.visible = false;
    },
    okHandler: function okHandler() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var ext, res, _JSON$parse, uuid, asset;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.currentSelectedFile.length) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', _this2.$message({
                  type: 'warning',
                  message: '请选择预设bin'
                }));

              case 2:
                ext = _this2.currentSelectedFile[0].split('.').pop();

                if (!(ext !== 'bin')) {
                  _context.next = 6;
                  break;
                }

                _this2.$refs.fileList.clearSelection();
                return _context.abrupt('return', _this2.$message({
                  type: 'warning',
                  message: '请选择预设bin'
                }));

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return readFile({
                  pid: _this2.projectKey,
                  path: _this2.currentSelectedFile[0]
                });

              case 10:
                res = _context.sent;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                console.log('error', _context.t0);

              case 16:
                _JSON$parse = JSON.parse(res[0]), uuid = _JSON$parse.uuid;
                _context.next = 19;
                return qcAssetLoadAsync(uuid, _this2.uuid2url[uuid]);

              case 19:
                asset = _context.sent;

                _this2.$emit('selectPrefab', asset);

                _this2.dialogProps.visible = false;
                _this2.$refs.fileList.clearSelection();

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[7, 13]]);
      }))();
    },
    changeDirectory: function changeDirectory(arr) {
      console.log(arr);
      this.curDir = arr.name;
      this.stacks.push(this.cloneLists);
      if (arr.items) {
        this.dirStacks.push(arr.name);
      }
      this.cloneLists = arr.items.sort(function (a, b) {
        return b.is_dir - a.is_dir;
      });
    },
    getCurrSection: function getCurrSection(arr) {
      this.currentSelectedFile = arr;
    },
    isLoding: function isLoding(param) {
      if (param) this.loadingTitle = '加载中';
      this.loading = param;
    },
    backToPrevious: function backToPrevious() {
      if (this.stacks.length !== 0) {
        this.cloneLists = this.stacks.pop();
        this.dirStacks.pop();
        this.curDir = this.dirStacks[this.dirStacks.length - 1];
      } else {
        this.curDir = '/resource/prefab/';
      }
    }
  }
};